import { Facade } from '@niknevis/vue-modules'
import InertiaService from '@/modules/shared/helpers/http/services/inertia.service'

export class Inertia extends Facade<InertiaService>() {
  static getFacadeAccessor() {
    return InertiaService
  }
}
